import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import api from "@/lib/api";

export default function CommunityVoice() {
  const [voices, setVoices] = useState(null);

  useEffect(() => {
    api.get("/community-voice").then(({ data }) => setVoices(data)).catch(() => setVoices([]));
  }, []);

  return (
    <div className="min-h-screen bg-forge-900 text-forge-100">
      <Header />
      <main className="max-w-4xl mx-auto px-6 lg:px-10 py-16 sm:py-24">
        <div className="text-[10px] tracking-[0.4em] uppercase text-gold-500 mb-4">Community Voice</div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mb-3 text-balance" data-testid="voice-title">
          What schools should teach better.
        </h1>
        <p className="font-reading text-lg text-forge-100/70 leading-relaxed max-w-2xl mb-12">
          Honest answers from the Founding ThoughtSmith™ Community. Anonymized to a first name and role,
          published with permission, ordered by most recent.
        </p>

        {voices === null ? (
          <p className="text-sm text-forge-100/40">Loading…</p>
        ) : voices.length === 0 ? (
          <div className="border border-dashed border-white/10 rounded-sm p-12 text-center">
            <p className="text-sm text-forge-100/60 mb-4">No voices yet. Add yours.</p>
            <Link to="/community" className="inline-block px-5 py-2.5 bg-ember-500 hover:bg-ember-400 text-forge-900 font-semibold rounded-sm tracking-wide transition-all" data-testid="voice-cta-join">
              Become a Founding ThoughtSmith™
            </Link>
          </div>
        ) : (
          <ul className="space-y-8" data-testid="voice-list">
            {voices.map((v, i) => (
              <li key={i} className="border-l-2 border-gold-500/60 pl-6 py-1">
                <p className="font-serif text-2xl sm:text-3xl text-forge-100 leading-snug text-balance">"{v.wish}"</p>
                <div className="mt-3 text-xs uppercase tracking-[0.3em] text-forge-100/45">
                  — {v.first_name ? `${v.first_name}, ` : ""}{v.role}
                </div>
              </li>
            ))}
          </ul>
        )}

        <div className="mt-16 border border-white/10 rounded-sm p-6 sm:p-8 bg-forge-800/40 flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-ember-500 mb-1">Add Your Voice</div>
            <p className="font-serif text-xl text-forge-100">What is one thing you wish schools taught better?</p>
          </div>
          <Link to="/community" className="px-5 py-2.5 bg-ember-500 hover:bg-ember-400 text-forge-900 font-semibold tracking-wide rounded-sm transition-all whitespace-nowrap" data-testid="voice-cta-bottom">
            Join the Community
          </Link>
        </div>
      </main>
    </div>
  );
}
